import React from "react"
import PropTypes from "prop-types"
import { Card, CardBody, Table } from "reactstrap"
import { useTranslation } from "react-i18next"
import { headerBits } from "../../constants/tableConstants"
import { renderAllRows } from './RowRenderer'

const BitMatrixTable = ({ byteIndex, rows, onBitToggle, builderData, pageKey, currentHexValue }) => {
  const { t } = useTranslation()
  
  const handleCellClick = (bit, currentValue) => {
    if (onBitToggle) {
      onBitToggle(byteIndex, bit, currentValue)
    }
  }
  
  return (
    <Card className="mb-3" style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}>
      <CardBody className="p-0">

        <div className="px-3 py-3">
          <Table bordered className="mb-0" size="sm">
            <thead>
              <tr style={{backgroundColor: '#ffffff', borderColor: '#dee2e6'}}>
                {headerBits.map(h => (
                  <th key={`h-${h}`} className="text-center" style={{width: '32px', height: '30px', backgroundColor: '#ffffff', borderColor: '#dee2e6'}}>
                    b{h}
                  </th>
                ))}
                <th className="text-center" style={{fontSize: '0.9rem', backgroundColor: '#ffffff', borderColor: '#dee2e6'}}>{t("aip.meaning", "Meaning")}</th>
              </tr>
            </thead>
            <tbody>
              {renderAllRows(rows, byteIndex, pageKey, builderData, currentHexValue, handleCellClick)}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  )
}

BitMatrixTable.propTypes = {
  byteIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    bit: PropTypes.number.isRequired,
    meaning: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
  })).isRequired,
  onBitToggle: PropTypes.func,
  builderData: PropTypes.object,
  pageKey: PropTypes.string,
  currentHexValue: PropTypes.string,
}

export default BitMatrixTable